import Vue from "vue";

Vue.directive('open-mobile-filter', {

    bind(el){
        el.onclick = event => {
            event.preventDefault();
            vueApp.$refs.categoryFilter.openFilter();
        }
    },
});
